/* import __COLOCATED_TEMPLATE__ from './jobs-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';
import type { JobGroupObject } from 'embercom/components/reporting/automation/ai-insights/fin-insights/jobs';
import type { ReportState } from 'embercom/components/reporting/custom/report/chart-card';

interface Signature {
  Args: {
    jobGroupObjects: readonly JobGroupObject[];
    selectedJobGroup: string;
    onJobGroupClick: (jobGroupId: string) => void;
    reportState: ReportState;
  };
}

const JobsCard = templateOnlyComponent<Signature>();
export default JobsCard;
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::JobsCard': typeof JobsCard;
    'reporting/automation/ai-insights/optimize/jobs-card': typeof JobsCard;
  }
}
